export default "__VITE_ASSET__DEUwql_D__"